module.exports = __webpack_public_path__ + "img/about-img5.5e95c8ec.png";